import { render, staticRenderFns } from "./CheckoutBtn.vue?vue&type=template&id=62284793&"
import script from "./CheckoutBtn.vue?vue&type=script&lang=js&"
export * from "./CheckoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports